import { Box, FormLabel, Grid } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTestOpenAIConnectionMutation } from "app/features/api/AuthApi";
import ErrorMessageComponent from "components/FormikErrorMessage";
import SuiButton from "components/SuiButton";
import SuiDropDownList from "components/SuiDropDownList";
import AccountTypeDropdown from "components/SuiDropDownList/AccountTypeDropdown";
import SuiPasswordInput from "components/SuiPasswordInput";
import WrapCard from "Container/Cards/WrapCard";
import { useState } from "react";
import SuiTypography from "components/SuiTypography";

const CONNECTION_STATUS_TIMEOUT = 3 * 1000;

function TenantOpenAIConfig({ formik, modelsList }){
    const [TestOpenAIConnection, { isLoading: isTestingConnection }] =
      useTestOpenAIConnectionMutation();

        const [connectionStatus, setConnectionStatus] = useState(null);
      

        function renderConnectionStatus() {
          if (!connectionStatus) return null;
      
          const { message, statusCode } = connectionStatus;
          const isSuccess = statusCode === 200;
      
          return (
            <Box display="flex" gap={1} alignItems="center" ml={2}>
              {isSuccess ? (
                <>
                  <VerifiedIcon fontSize="medium" sx={{ color: "#86CC27" }} />
                  <SuiTypography fontSize={13} sx={{ color: "#86CC27 !important" }}>
                    {message}
                  </SuiTypography>
                </>
              ) : (
                <>
                  <WarningAmberIcon fontSize="medium" sx={{ color: "#FF1733" }} />
                  <SuiTypography fontSize={13} sx={{ color: "#FF1733 !important" }}>
                    Invalid OpenAI credentials. Please try again.
                  </SuiTypography>
                </>
              )}
            </Box>
          );
        }
  async function testOpenAIConnectionHandler() {
    try {
      const token = localStorage.getItem("auth_token_admin");
      const { aiAccessKey, aiModelName } = formik.values;

      const body = {
        access_key: aiAccessKey,
        model: aiModelName,
        token,
      };

      const data = await TestOpenAIConnection(body).unwrap();
      setConnectionStatus(data);
    } catch (error) {
      setConnectionStatus({
        message: error?.data?.message,
        statusCode: error.status,
      });
    } finally {
      // hide message after 3 seconds
      setTimeout(() => {
        setConnectionStatus(null);
      }, CONNECTION_STATUS_TIMEOUT);
    }
  }

    return(
        <WrapCard fontWeight="semiBold" title="OpenAI Configuration">
        <Grid container spacing={2} component="form">
          <Grid item xs={8} mt={2}>
            <FormLabel htmlFor="api_key">
              API Key
            </FormLabel>
            <SuiPasswordInput
              attr={{ name: "aiAccessKey", placeholder: "Enter AI access key" }}
              getValue={formik.handleChange}
              name="aiAccessKey"
              value={formik.values.aiAccessKey}
              onBlur={formik.onBlur}
            //   className={classes.inputField}
              onChange={formik.handleChange}
              id="aiAccessKey"
              type="aiAccessKey"
            />
            <ErrorMessageComponent
              touched={formik.touched.aiAccessKey}
              error={formik.errors.aiAccessKey}
            />
          </Grid>
  
          <Grid item xs={4} mt={2}>
            <FormLabel htmlFor="model">
              Model
            </FormLabel>
            {/* <SuiDropDownList
              data={modelsList}
              onBlur={formik.handleBlur}
              select={{
                key: "id",
                valueKey: "id",
                labelName: "label",
                label: "Select Model",
                name: "aiModelName",
                val: formik.values.aiModelName,
                fn: formik.handleChange
              }}
            /> */}
            {console.log({ aiModelName: formik.values.aiModelName })}
            <AccountTypeDropdown
              data={modelsList}
              name="aiModelName"
              value={formik.values.aiModelName || ""}
              setValue={formik.handleChange}
              placeHolder="Select Model"
              onBlur={formik.handleBlur}
              formik={formik}
            />
            <ErrorMessageComponent
              touched={formik.touched.aiModelName}
              error={formik.errors.aiModelName}
            />
          </Grid>
  
          <Grid item xs={6} mt={2}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <SuiButton
                size="small"
                buttonColor="info"
                disabled={!formik.values.aiAccessKey || !formik.values.aiModelName}
                onClick={testOpenAIConnectionHandler}
                isLoading={isTestingConnection}
                sx={{
                  fontWeight: "500",
                  px: "12px",
                  backgroundColor: "#161740 !important",
                }}
              >
                Test Connection
              </SuiButton>
              {renderConnectionStatus()}
            </Box>
          </Grid>
        </Grid>
        {/* </div> */}
      </WrapCard>
    )
}

export default TenantOpenAIConfig;
